import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from 'components/v2/card/Card';
import CardHeader from 'components/v2/card/CardHeader';
import CardFooter from 'components/v2/card/CardFooter';
import { showToast } from 'stores/ToastStore';
import { useCreateWarehouseWithAssociations } from 'hooks/warehouse/useManageWarehouse';
import WarehouseForm from './WarehouseForm';

const AddWarehouse = ({ data, onCancel }) => {
  const [saving, setSaving] = useState(false);
  const { t } = useTranslation();

  const onSaveSuccess = (response) => {
    setSaving(false);
    if (response?.unprocessed_items?.length) {
      if (response.unprocessed_items.length === 1) {
        showToast('', response.unprocessed_items[0].message, 'error');
      } else {
        const errorMessages = response.unprocessed_items.map(
          (err, idx) => `${idx + 1}. ${err.message} \n`,
        );
        showToast('', errorMessages, 'error');
      }
      return;
    }
    showToast('', t('CREATE_WAREHOUSE_SUCCESS'), 'success');
    onCancel();
  };

  const onSaveFail = () => {
    setSaving(false);
    showToast('', t('CREATE_WAREHOUSE_FAILED'), 'error');
  };

  const { mutation: createMutation } = useCreateWarehouseWithAssociations(
    onSaveSuccess,
    onSaveFail,
  );

  const handleCreateWarehouse = async (payload) => {
    setSaving(true);
    await createMutation.mutateAsync(payload);
  };

  const onValidSuccess = (data) => {
    handleCreateWarehouse(data);
  };

  const onValidFail = () => {
    setSaving(false);
  };

  const renderHeader = () => {
    return <CardHeader title={t('ADD_WAREHOUSE')} />;
  };

  const renderFooter = () => {
    return (
      <CardFooter
        disabled={saving}
        onActionClick={() => {
          setSaving(true);
        }}
        onCancelClick={onCancel}
      />
    );
  };
  return (
    <Card header={renderHeader} footer={renderFooter}>
      <WarehouseForm
        data={{}}
        saving={saving}
        onValidFail={onValidFail}
        onValidSuccess={onValidSuccess}
        afterSave={() => {
          setSaving(false);
        }}
      />
    </Card>
  );
};

export default AddWarehouse;
